<template>
  <div id="app">
    <PcBanner v-if="type === 'pc'" />
    <AppBanner v-else />
  </div>
</template>

<script>
import PcBanner from "./components/PcBanner.vue";
import AppBanner from "./components/AppBanner.vue";

export default {
  name: "App",
  components: {
    PcBanner,
    AppBanner
  },

  created() {
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      this.type = "app";
    }
  },
  data() {
    return {
      type: "pc",
    };
  },
};
</script>

<style>
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>
